import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance"];
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { useFocusMode } from "../focusMode";
import { BaseButton } from "./BaseButton";
export var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? "link" : _ref$appearance,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFocusMode = useFocusMode({
      isDisabled: appearance !== "button-borderless"
    }),
    focusMode = _useFocusMode.focusMode;
  return jsx(BaseButton, _extends({}, props, {
    appearance: appearance,
    innerRef: ref,
    focusMode: focusMode,
    renderAs: "a"
  }));
});
//# sourceMappingURL=Link.js.map